import Box from '@/common/components/Box'
import Skeleton from '@/common/components/Skeleton'

export const BillDetailsSectionLoadingState = () => {
  return (
    <Box className="p-4 flex flex-col gap-y-4">
      <div className="flex items-center gap-x-3">
        <Skeleton width={75} height={34} className="bg-white-100" />

        <Skeleton width={176} height={28} />
      </div>

      <div className="flex items-center gap-x-2">
        <Skeleton width={76} height={12} />

        <div className="flex items-center gap-x-1 text-white-400">
          <Skeleton width={20} height={20} circle className="bg-white-100" />

          <Skeleton width={120} height={16} />
        </div>
      </div>

      <div className="flex items-center gap-x-2">
        <Skeleton width={80} height={12} />

        <div className="flex items-center gap-x-1 text-white-400">
          <Skeleton width={20} height={20} circle className="bg-white-100" />

          <Skeleton width={24} height={16} />
        </div>
      </div>

      <div className="flex items-center gap-x-2">
        <Skeleton width={116} height={12} />

        <div className="flex items-center gap-x-1 text-white-400">
          <Skeleton width={20} height={20} circle className="bg-white-100" />

          <Skeleton width={32} height={16} />
        </div>
      </div>
    </Box>
  )
}
